import { createAction } from "redux-actions";
import { LOADING_PAGE } from "../constants";

export const loadingState = createAction(LOADING_PAGE, (state) => state)
